module.exports = __webpack_public_path__ + "static/media/service.1ed14055.svg";